<template>
  <section id="mission" class="py-16 md:py-24">
    <div class="max-w-7xl mx-auto px-4 md:px-8">
      <div class="mb-10 md:mb-14">
        <h2 class="text-3xl md:text-4xl font-bold mb-3">{{ $t('mission.title') }}</h2>
        <p class="text-text-secondary text-lg max-w-2xl">
          {{ $t('mission.description') }}
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div
          v-for="(item, index) in values"
          :key="item.icon"
          class="card-brutal p-6 h-full"
        >
          <div
            class="inline-flex items-center justify-center w-10 h-10 rounded-md border-2 border-border mb-4"
            :class="item.iconBg"
          >
            <!-- Infra -->
            <svg
              v-if="item.icon === 'infra'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="2" y="3" width="20" height="6" rx="2" />
              <rect x="2" y="15" width="20" height="6" rx="2" />
              <path d="M6 6h.01" />
              <path d="M6 18h.01" />
            </svg>

            <!-- Builders -->
            <svg
              v-else-if="item.icon === 'builders'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path d="M22 10l-10-6-10 6 10 6 10-6z" />
              <path d="M6 12v5a6 3 0 0 0 12 0v-5" />
            </svg>

            <!-- Apps -->
            <svg
              v-else-if="item.icon === 'apps'"
              class="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <rect x="3" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="3" width="7" height="7" rx="1" />
              <rect x="14" y="14" width="7" height="7" rx="1" />
              <rect x="3" y="14" width="7" height="7" rx="1" />
            </svg>
          </div>
          <h3 class="text-xl font-bold mb-2">{{ $t(`mission.items[${index}].title`) }}</h3>
          <p class="text-text-secondary leading-relaxed">{{ $t(`mission.items[${index}].description`) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const values = [
  { iconBg: 'bg-primary', icon: 'infra' },
  { iconBg: 'bg-accent', icon: 'builders' },
  { iconBg: 'bg-brutal-lime', icon: 'apps' },
];
</script>
